import Filter from '@/ui/components/filter';
import { ALL_OPTION } from '@/ui/constants';
import useEnabledAssets from '@/ui/hooks/use-enabled-assets';
import showFilterActivityTypesModal from '@/ui/modals/filter-activity-types-modal';
import showFilterTokensModal from '@/ui/modals/filter-tokens-modal';
import { isAllOption } from '@/ui/utils/content';
import type { ActivityTypeSelection, AssetSelection } from '../types.js';

export interface FiltersProps {
  selectedAssets: AssetSelection;
  onSelectedAssetsChange: (selectedAssets: AssetSelection) => void;
  selectedActivityTypes: ActivityTypeSelection;
  onSelectedActivityTypesChange: (
    selectedActivityTypes: ActivityTypeSelection,
  ) => void;
}

function Filters({
  selectedAssets,
  onSelectedAssetsChange,
  selectedActivityTypes,
  onSelectedActivityTypesChange,
}: FiltersProps) {
  const allActivityTypes = isAllOption(selectedActivityTypes);
  const allAssets = isAllOption(selectedAssets);

  // TODO: Use only assets for which there is activity.
  const assets = useEnabledAssets();

  const handleTokenFilterClick = async () => {
    const { result: newAssets } = await showFilterTokensModal({
      assets: Object.values(assets),
      defaultAssets: allAssets ? [] : selectedAssets,
    });
    if (newAssets) {
      onSelectedAssetsChange(newAssets);
    }
  };

  const handleActivityTypeFilterClick = async () => {
    const { result: activityTypes } = await showFilterActivityTypesModal({
      defaultTypes: allActivityTypes ? [] : selectedActivityTypes,
    });

    if (activityTypes) {
      onSelectedActivityTypesChange(
        isAllOption(activityTypes) ? ALL_OPTION : activityTypes,
      );
    }
  };

  return (
    <div className="mb-2 grid w-full grid-cols-2 gap-2">
      <Filter
        onClick={handleActivityTypeFilterClick}
        value={
          allActivityTypes
            ? 'All types'
            : selectedActivityTypes
                .map((activityType) => activityType.label)
                .join(', ')
        }
        dataTestId="filter-type-button"
      />
      <Filter
        onClick={handleTokenFilterClick}
        value={
          allAssets
            ? 'All tokens'
            : selectedAssets.map((asset) => asset.displayTicker).join(', ')
        }
        dataTestId="filter-tokens-button"
      />
    </div>
  );
}

export default Filters;
